import { Form, Formik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SubmitButton from '../common/buttons/submitButton/SubmitButton';
import TextInput from '../common/inputs/textInput/TextInput';

import { changePassword } from '../../store/actions/currentUser';
import { changePasswordInitValues, changePasswordValidationSchema } from './profileUtils';

const ChangePassword: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = async (values: typeof changePasswordInitValues) => {
    try {
      await dispatch(changePassword(values));
      toast.success(t('auth.passwordChanged'));
    } catch (errors: any) {
      toast.error(`${t('auth.errorPrefix')} ${errors.join(' | ')}`);
    }
  };

  return (
    <Formik
      initialValues={changePasswordInitValues}
      onSubmit={handleSubmit}
      validationSchema={changePasswordValidationSchema}
    >
      {({ isSubmitting }) => (
        <Form className='m-12'>
          <fieldset className='flex flex-col gap-2 max-w-md mx-auto' disabled={isSubmitting}>
            <TextInput
              className='py-8 px-18'
              name='currentPassword'
              label={t('auth.password')}
              placeholder={t('auth.enterPassword')}
              type='password'
            />
            <TextInput
              className='py-8 px-18'
              name='newPassword'
              label={t('auth.newPassword')}
              placeholder={t('auth.enterNewPassword')}
              type='password'
            />
            <TextInput
              className='py-8 px-18'
              name='newPasswordCopy'
              label={t('auth.repeatNewPassword')}
              placeholder={t('auth.repeatNewPassword')}
              type='password'
            />
          </fieldset>

          <SubmitButton isSubmitting={isSubmitting} type='submit' className='mx-auto mt-8'>
            {t('auth.changePassword')}
          </SubmitButton>
        </Form>
      )}
    </Formik>
  );
};

export default ChangePassword;
